
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/shipping",
      function () {
        return require("private-next-pages/[lang]/shipping.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/shipping"])
      });
    }
  